import {
  Bell, CircleCheck, Flag, Image as ImageIcon, Receipt, Wallet, MapPin, Info,
} from "lucide-react";

import { useResource } from "../lib/useApi";
import { date } from "../lib/fmt";
import { Sheet, Glass, Skeleton, Err, Empty } from "../ui";

/**
 * The client's own feed. Opening it marks everything read — that POST happens
 * here rather than in the bell, so a mis-tap on the bell does not silently
 * clear a badge the client never looked at.
 */

const ICON = {
  task: CircleCheck, milestone: Flag, design: ImageIcon,
  invoice: Receipt, payment: Wallet, visit: MapPin, update: Info,
};

export function UpdatesSheet({ ctx, onClose }) {
  const { pid } = ctx;
  const { data, loading, error, reload } = useResource(`/portal/notifications?project_id=${pid}`);

  const items = data?.items || [];

  return (
    <Sheet title="Updates" onClose={onClose}>
      <Err onDismiss={reload}>{error}</Err>

      {loading && <Skeleton h={72} />}

      {!loading && !items.length && (
        <Empty icon={Bell} title="No updates yet" note="Every task completed, milestone reached and design released lands here." />
      )}

      {items.map((n) => {
        const Icon = ICON[n.type] || Info;
        const unread = !n.read_at;
        return (
          <Glass className="row" key={n.id} strong={unread}>
            <span
              className="row-ic"
              style={unread ? { background: "var(--mag-tint)", color: "var(--mag-btn)" } : undefined}
            >
              <Icon size={16} />
            </span>
            <span className="row-txt">
              <b style={{ fontWeight: unread ? 600 : 500 }}>{n.title}</b>
              {n.body && <small>{n.body}</small>}
              <small className="muted">{date(n.created_at)}</small>
            </span>
          </Glass>
        );
      })}
    </Sheet>
  );
}

/** Marks the feed read. Called by App once the sheet has actually opened. */
export async function markUpdatesRead(api, pid) {
  try { await api.post(`/portal/notifications?project_id=${pid}`, {}); } catch { /* never blocks */ }
}
